import { updatePatch } from "../../../utils";
export const getHoursOfOperationUpdatePayload = ({
  initialSla,
  initialTargetResponseTime,
  initialSupportHours,
  sla,
  targetResponseTime,
  supportHours
}) => {
  const patches = [];
  updatePatch(initialSla, sla, '/vendorLinks/sla', patches);
  updatePatch(initialTargetResponseTime, targetResponseTime, '/supportDetails/targetResponseTime', patches);
  updatePatch(initialSupportHours, supportHours, '/supportDetails/supportHours/', patches);
  return patches;
};